<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <NuxtLoadingIndicator color="#0000e5" />
</template>

<script setup lang="ts">
import { useTranslationStore } from '~/store/translation'
import { useI18n } from 'vue-i18n'

const i18n = useI18n()
const translationStore = useTranslationStore()
const locale = i18n.locale.value

await useAsyncData(`translations:${locale}`, async () => await translationStore.load({ locale }))
i18n.mergeLocaleMessage(translationStore.locale, translationStore.translations)
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>
